export type ClassName = string;

export const toClassName = (classNameString: string): ClassName => classNameString;

export const getStyle = (className: ClassName | ClassName[]) => ({
	className: Array.isArray(className) ? className.join(' ') : className,
});
